import ruleDetailsItem from 'pages/rules/ruleDetailItem';
import { RuleApplicability } from 'pages/rules/subComponents';
import { ruleTypeItem } from 'pages/rules/collapseItem';
import FeelExpressionForm from 'pages/rules/feelExpressionForm';
import { Col } from 'antd';
import PureNumberInput from 'components/number/pureNumberInput';

export default function buildRuleTabs({
  t,
  form,
  type,
  ruleGroupDate,
  ruleType,
  state,
  fileType,
  uploadType,
  clawbackType,
  isFlatAmountMode,
  skipAllOtherTabs,
  isClawbackPartial,
  showRuleApplicability,
  showFeelExpression,
  adjustmentLevel,
  outputFormulaConfigFields,
  hasGridView,
  tagsChecked,
}) {
  const detailsTabContent = (
    <>
      {ruleDetailsItem({
        form,
        type,
        ruleGroupDate,
        disabled: false,
        t,
        ruleType,
        tagsChecked,
      })}
      {isFlatAmountMode ? (
        <Col md={6}>
          <PureNumberInput
            label="Enter Amount"
            name="enter_amount"
            required={true}
            message="Please enter an amount"
            placeholder="Enter amount"
            disabled={type === 'Show'}
          />
        </Col>
      ) : null}
    </>
  );

  const detailsTab = {
    key: 'details',
    label: t('rules.ruleDetails'),
    children: detailsTabContent,
  };

  const payoutMatrixTab = {
    key: 'payoutMatrix',
    label: t('rules.payoutMatrix'),
    children: ruleTypeItem(fileType, [], uploadType, form, type, clawbackType),
  };

  if (skipAllOtherTabs) return [detailsTab];

  if (isClawbackPartial) {
    return hasGridView ? [detailsTab, payoutMatrixTab] : [detailsTab];
  }

  const isGroupAdjustment = adjustmentLevel === 'group';
  const tabs = [detailsTab];

  if (!isGroupAdjustment && showRuleApplicability) {
    tabs.push({
      key: 'applyRule',
      label: t('rules.qbApplyLabel'),
      children: (
        <RuleApplicability
          type={type}
          form={form}
          configFields={state.configFields}
          disabled={type === 'Show'}
          ruleApplicabilityError={state.ruleApplicabilityError}
          isSavedClick={state.isSavedClick}
        />
      ),
    });
  }

  if (hasGridView) {
    tabs.push(payoutMatrixTab);
  }

  if (showFeelExpression) {
    tabs.push({
      key: 'outputFormula',
      label: t('rules.qbPayoutLabel'),
      children: (
        <FeelExpressionForm
          type={type}
          disabled={type === 'Show'}
          form={form}
          configFields={outputFormulaConfigFields}
        />
      ),
    });
  }

  return tabs;
}
